<template>
  <Flex class="c_related_product_container">
    <div class="c_related_product_container__item">
      <nuxt-link
        class="c_related_product_container__item__image_container"
        :to="localePath(`/${product.uri}`)"
        v-if="product.productFeaturedImage?.[0]?.galleryEnlarged"
      >
        <MediaImage
          :sources="[product.productFeaturedImage?.[0]?.galleryEnlarged]"
          :alt="product.productFeaturedImage?.[0]?.title"
        />
      </nuxt-link>
      <div class="c_related_product_container__item__content">
        <nuxt-link class="c_related_product_container__item__content__title" :to="localePath(`/${product.uri}`)">
          {{ product.relatedProductTitle ?? product.title }}
        </nuxt-link>
        <div
          class="c_related_product_container__item__content__description"
          v-html="product.relatedProductDescription"
          v-if="product.relatedProductDescription"
        ></div>
        <div class="c_related_product_container__item__content__btn_container">
          <nuxt-link class="c_button_2022" :to="localePath(`/${product.uri}`)">
            {{ $t('View Product') }}
          </nuxt-link>
        </div>
      </div>
    </div>
  </Flex>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import Flex from 'Components/flex/Flex.vue';
import MediaImage from 'Components/image/MediaImage.vue';

export default defineComponent({
  name: 'RelatedProductV2',
  components: { Flex, MediaImage },
  props: {
    product: { type: Object, default: () => {} },
  },
  setup(props) {},
});
</script>

<style lang="scss">
.c_related_product_container {
  --related-product-btn-bg: var(--color-black);
  --related-product-btn-color: var(--color-white);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  max-width: 100%;
  grid-auto-columns: minmax(0, 1fr);
  grid-column-gap: px_to_rem(15);
  padding-left: 0;
  padding-right: 0;
  @include mq($mq_md_to_lg) {
    max-width: 33.333%;
    grid-auto-columns: minmax(0, 33.333%);
  }
  @include mq($mq_sm_to_md) {
    max-width: 50%;
    padding-left: px_to_rem(10);
    padding-right: px_to_rem(10);
    grid-auto-columns: minmax(0, 50%);
  }
  &__item {
    border-radius: px_to_rem(10);
    border: 1px solid $color_gray_201;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    width: 100%;
    &__image_container {
      aspect-ratio: 16/9;
      position: relative;
      width: 100%;
      overflow: hidden;
      background-color: #f3f3f3;
      flex: 0 0 auto;
      figure {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    &__content {
      padding: px_to_rem(18) px_to_rem(24);
      height: 100%;
      display: flex;
      flex-direction: column;
      &__title {
        @include fs_lh(24, 32, 24, 32);
        @include font('graphik_medium');
        color: $color_black;
        text-decoration: none;
        display: block;
        &:hover {
          text-decoration: underline;
        }
      }
      &__description {
        margin-top: px_to_rem(12);
      }
      &__btn_container {
        margin-top: auto;
      }
    }
    .c_button_2022 {
      margin-top: px_to_rem(32);
      background-color: var(--related-product-btn-bg);
      color: var(--related-product-btn-color);
      border: 2px solid transparent;
      width: 100%;
      &:hover {
        background-color: var(--related-product-btn-color);
        color: var(--related-product-btn-bg);
        border-color: var(--related-product-btn-bg);
      }
    }
  }
}
</style>
